import React, { Component } from 'react';
import { withRouter } from 'react-router';

import style from './ProviderScheduling.scss';

import ProviderCalendar from './ProviderCalendar';
import ProviderCard from './ProviderCard';

import ProviderPageFlashMessage from './ProviderPageFlashMessage';

class ProviderBody extends Component {
  render() {
    const {
      history: { location },
      showFlashMessage,
    } = this.props;

    return (
      <div className={style['provider-widget']}>
        {showFlashMessage && <ProviderPageFlashMessage location={location} marginBottom="sm" />}

        <div className={style['provider-widget__body']}>
          <div className={style['provider-widget__calendar']}>
            <ProviderCalendar {...this.props} />
          </div>
          <ProviderCard {...this.props} />
        </div>
      </div>
    );
  }
}

export default withRouter(ProviderBody);
